import React, { Component } from 'react'
import styles from './pending-wwc.styl'
import { FormattedMessage } from 'react-intl'
import { Title } from '../../misc'
import { ElevatedButton, FixedRightBottom } from '../index'
import MODALS from '../../../constants/layout/modals'
import { modal } from '../../../helpers/decorators'
import PropTypes from 'prop-types'

@modal.trigger()
class PendingWWC extends Component {
  static propTypes = {
    onOpen: PropTypes.func.isRequired
  }

  handleOpenWWCDialog = () => this.props.onOpen(MODALS.WWC_STATUS)

  render() {
    return (
      <div className={styles.wrapper}>
        <Title h1>
          <FormattedMessage
            id="moduleTitle.welcome_to_the_orb"
            defaultMessage="Welcome to the Online Record Book"
          />
        </Title>
        <p className={styles.message}>
          <FormattedMessage
            id="label.your_clearance_is_pending"
            defaultMessage="Your clearance is pending Award Leader approval."
          />
        </p>

        <FixedRightBottom>
          <ElevatedButton
            onClick={this.handleOpenWWCDialog}
            intlKey="button.your_wwc_has_expired"
            large
          >
            Your WWC has expired
          </ElevatedButton>
        </FixedRightBottom>
      </div>
    )
  }
}

export default PendingWWC
